// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.person.diagnosis.CarePlanItemResponse */
/* istanbul ignore next */
@GandalfModel
export class CarePlanItemResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	allowPullForward!: boolean | null;

	@GandalfConstantDecorator(constants.CarePlanItemCategory)
	@GandalfProperty({ designType: constants.CarePlanItemCategory })
	category!: constants.CarePlanItemCategory | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	recallLocationId!: number | null;

	@GandalfProperty({ designType: String })
	recallLocationName!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	stopDate!: Date | null;

}
